import styled from "styled-components";

const MapContainer = styled.div`
    width: 100%;
    flex-grow: 1;
`;

export { MapContainer };
